export const BLOGS_DATA = [
  {
    id: "agents",
    title: "دليلك الشامل للانضمام لشبكة وكلاء ليزرجيت المعتمدين في مصر",
    desc: "شراكة عمل متكاملة تمنحك حق تمثيل 'ليزرجيت' في منطقتك الجغرافية، لتكون جزءاً من شبكة وكلاءنا المعتمدين في مصر وتستغل الفرص الواعدة.",
    imageSrc: "/Partners.jpeg", 
    category: "استثمار وشراكة",
    author: "إدارة ليزرجيت",
    date: "23 يونيو 2026",
    readTime: "5 دقائق قراءة",
    isFeatured: true,
    tags: ["وكلاء", "استثمار", "الأجهزة المنزلية", "شراكة"],
    features: [
      "تمثيل العلامة التجارية الرائدة في قطاع الأجهزة المنزلية.",
      "امتيازات حصرية وأسعار خاصة وأولوية في المنتجات الجديدة.",
      "دعم تسويقي شامل ومواد دعائية احترافية.",
      "تدريب وتطوير مستمر لفريق عملك إدارياً وفنياً.",
      "نظام إمداد وتوريد قوي يضمن سرعة الشحن وتوافر المخزون.",
      "إدارة مخصصة لمتابعة عملياتك وتذليل التحديات."
    ],
    content: [
      "تعتبر شركة ليزرجيت مصر واحدة من أسرع الشركات نمواً في سوق الأجهزة المنزلية والإلكترونيات، حيث نحرص على تقديم منتجات مبتكرة ذات موثوقية عالية تلبي احتياجات الأسرة المصرية. إن انضمامك لشبكة وكلائنا المعتمدين يمثل خطوة استثمارية استراتيجية تتيح لك التوسع في منطقتك الجغرافية بحماية تامة وحقوق تمثيل حصرية.",
      "نحن نوفر لوكلائنا حزمة متكاملة من الدعم الفني، الإداري والتسويقي. نلتزم بتدريب طاقم العمل الخاص بك ليتمكن من تقديم أفضل مستويات الخدمة للعملاء، كما نمدك بكافة المواد الدعائية الاحترافية التي تساعدك على الانتشار وجذب المستهلكين بكفاءة عالية.",
      "تشمل شروط الحصول على الوكالة المعتمدة الالتزام الكامل بالهوية البصرية للماركة، وتوفير سجل تجاري ساري ومقر مناسب للنشاط، بالإضافة إلى القدرة التشغيلية والبيعية لتحقيق مستهدفات البيع المتفق عليها. نحن نؤمن بأن نجاح وكلائنا هو نجاح مباشر لنا، ولذلك نضع كل إمكانياتنا اللوجستية في خدمتكم لضمان سرعة التوريد واستقرار المخزون."
    ],
    contact: {
      title: "تقديم طلب الحصول على وكالة معتمدة",
      phone: "01004331113",
      web: "agents.laserjet.com.eg",
      email: "agents@laserjet.com.eg"
    }
  },
  {
    id: "partners",
    title: "كيف تحقق أرباحاً وعوائد مجزية من برنامج شركاء ليزرجيت للعمولات",
    desc: "فرصة استثمارية واعدة لتحقيق عوائد مادية من خلال تسويق منتجات 'ليزرجيت'. انضم لشبكة تمنحك عمولة مجزية وحرية عمل كاملة.",
    imageSrc: "/Partners.jpeg", 
    category: "استثمار وشراكة",
    author: "إدارة التسويق",
    date: "22 يونيو 2026",
    readTime: "4 دقائق قراءة",
    isFeatured: false,
    tags: ["عمولات", "تسويق", "شركاء", "أرباح"],
    features: [
      "عائد مادي تنافسي وعمولات مجزية عن كل عملية بيع يتم تأكيدها.",
      "حرية العمل الكاملة وتحديد أوقاتك بما يناسب التزاماتك اليومية.",
      "الترويج لمنتجات متنوعة ذات جودة عالية وطلب مرتفع في السوق.",
      "أدوات تسويقية وروابط تتبع متطورة لتسهيل وصولك للمشترين.",
      "لوحة تحكم شفافة لمتابعة المبيعات، الزيارات، والعمولات لحظياً.",
      "دعم مستمر من فريق مخصص لمساعدتك في حل التحديات التسويقية."
    ],
    content: [
      "في إطار سعينا لتمكين الأفراد وتوسيع آفاق الاستثمار والعمل الحر، أطلقنا برنامج 'شركاء ليزرجيت للعمولات'. هذا البرنامج مصمم خصيصاً لكل من يملك شغفاً بالتسويق أو يود بناء مصدر دخل إضافي مستدام من خلال الترويج لأجهزة ليزرجيت المنزلية والإلكترونية المميزة.",
      "عملية البدء في غاية السهولة والبساطة؛ كل ما عليك هو التسجيل عبر الموقع الإلكتروني المخصص للشركاء، والحصول على روابطك الفرعية والمواد التسويقية الخاصة بك. من خلال مشاركة هذه الروابط على منصات التواصل الاجتماعي أو مع شبكة علاقاتك، سيتم تسجيل أي عملية شراء تتم من خلالك بشكل آلي وحساب عمولتك فوراً.",
      "تتميز لوحة التحكم التي نوفرها لشركائنا بأعلى درجات الشفافية والأمان، حيث تعرض تقارير مفصلة عن حركة الروابط وحجم المبيعات والعمولات المستحقة ومواعيد صرفها بشكل دوري. انضم إلينا اليوم وابدأ في تحقيق أرباح حقيقية بمرونة كاملة ودون الحاجة لرأس مال أولي."
    ],
    contact: {
      title: "التسجيل في برنامج شركاء ليزرجيت",
      phone: "01004331113",
      web: "partners.laserjet.com.eg",
      email: "partners@laserjet.com.eg"
    }
  },
  {
    id: "service",
    title: "تأسيس وتشطيب منزلك: نصائح هندسية لتفادي أخطاء السباكة والكهرباء",
    desc: "حلول متكاملة للتأسيس والتشطيب تقدمها ليزرجيت سيرفيس. تعرف على كيفية إتمام تشطيب شقتك بمواصفات قياسية ودون عناء.",
    imageSrc: "/serves.jpeg", 
    category: "ليزرجيت سيرفيس",
    author: "م. أحمد رمزي",
    date: "20 يونيو 2026",
    readTime: "6 دقائق قراءة",
    isFeatured: false,
    tags: ["تشطيبات", "هندسة", "تأسيس", "سباكة"],
    features: [
      "التأسيس والتركيبات الفنية والتقنية بدقة عالية وفق الأصول الهندسية.",
      "التشطيبات المتكاملة والديكور الداخلي والخارجي وفق أحدث الطرز.",
      "إدارة المشروعات بالكامل لتوفير عناء التعامل مع مقاولي الباطن.",
      "ضمان حقيقي وموثق على كافة أعمال التركيبات والتشطيب الفنية.",
      "التسليم النهائي للموقع (على المفتاح) مطابقاً بنسبة 100% للمواصفات."
    ],
    content: [
      "مرحلة تأسيس السباكة والكهرباء هي العمود الفقري لأي عملية تشطيب ناجحة. الخطأ في هذه المرحلة قد يكلفك مبالغ طائلة مستقبلاً ويتطلب تكسيراً وإعادة عمل من الصفر. لذلك، يحرص طاقمنا الهندسي في 'ليزرجيت سيرفيس' على اتباع معايير جودة صارمة لضمان سلامة واستدامة كل أنظمة التشغيل في المنزل.",
      "من النصائح الأساسية التي نركز عليها دائماً هي التأكد من جودة الخامات المستخدمة واعتمادها من الشركات المصنعة لضمان الحصول على شهادات الضمان الطويلة. كما يجب عمل اختبارات ضغط للمواسير واختبارات عزل مائي للحمامات والمطابخ قبل البدء في مرحلة المحارة والتبليط لمنع أي تسريب مستقبلي.",
      "نوفر في ليزرجيت سيرفيس خدمة إدارة المشاريع المتكاملة، حيث نقوم باستلام موقعك كخرسانة ونقوم بكافة أعمال التصميم ثلاثي الأبعاد، والتأسيس، والتشطيب، والديكور حتى تسليم المفتاح. نلتزم التزاماً كاملاً بالجدول الزمني المحدد وبالميزانية المتفق عليها دون أي زيادة مفاجئة، مما يمنحك راحة البال التامة طوال فترة العمل."
    ],
    contact: {
      title: "لطلب معاينة أو استشارة هندسية مجانية",
      phone: "01004331113",
      web: "service.laserjet.com.eg",
      email: "service@laserjet.com.eg"
    }
  },
  {
    id: "sell",
    title: "كيف تزيد مبيعاتك وتدير مخزونك الذكي عبر منصة التاجر الرقمي Sell",
    desc: "شراكة استراتيجية تتيح للتجار والشركات الوصول لقاعدة عملاء واسعة عبر منصة 'ليزرجيت' مع توفير كامل الدعم اللوجستي والتقني.",
    imageSrc: "/sell.jpeg", 
    category: "التاجر الرقمي",
    author: "فريق ليزرجيت التقني",
    date: "18 يونيو 2026",
    readTime: "5 دقائق قراءة",
    isFeatured: false,
    tags: ["التاجر الرقمي", "مبيعات", "مخزون", "تجارة إلكترونية"],
    features: [
      "قاعدة عملاء واسعة ونشطة تضمن انتشار وتطور علامتك التجارية.",
      "لوحة تحكم ذكية لإدارة المنتجات، الطلبات، المخزون، والأسعار بسهولة.",
      "نظام تقارير وتحليلات متقدمة لفهم سلوك العملاء وتوقع اتجاهات السوق.",
      "حلول لوجستية متطورة تشمل التخزين، التغليف، والشحن السريع للعملاء.",
      "دعم فني مخصص وتدريب لفريق عملك لضمان تحقيق أقصى استفادة.",
      "بوابات دفع آمنة ومتنوعة تضمن سرعة التحصيل والتسوية المالية للتجار."
    ],
    content: [
      "في عصر التحول الرقمي، لم يعد التواجد عبر الإنترنت رفاهية بل ضرورة حتمية لنمو أي نشاط تجاري. ولكن بناء متجر إلكتروني متكامل وتأمين خدمات الشحن والتحصيل قد يمثل عبئاً كبيراً. هنا يأتي دور منصة التاجر الرقمي 'Sell' من ليزرجيت، لتمنحك حلاً شاملاً وجاهزاً للبدء فوراً.",
      "توفر المنصة للتجار لوحة تحكم سحابية ذكية تتيح إضافة المنتجات وتعديل الأسعار ومتابعة مخزون السلع بكل مرونة. كما نربط متجرك بشبكة لوجستية قوية تتولى عمليات الشحن السريع لباب العميل وتحصيل المبالغ النقدية أو الإلكترونية، مع تسوية المستحقات المالية بحسابك البنكي بانتظام وبسرعة.",
      "تساعدك منصة Sell أيضاً في الاستفادة من الحملات التسويقية والترويجية التي تطلقها منصة ليزرجيت الأم، مما يضع منتجاتك أمام مئات الآلاف من المتسوقين يومياً ويزيد من فرص البيع والنمو لعملك بشكل مطرد وبأقل تكلفة تشغيلية ممكنة."
    ],
    contact: {
      title: "التسجيل كتاجر في منصة Sell",
      phone: "01004331113",
      web: "sell.laserjet.com.eg",
      email: "sell@laserjet.com.eg"
    }
  },
  {
    id: "minimoney",
    title: "كل ما تريد معرفته عن تقسيط الأجهزة الإلكترونية والمنزلية عبر ميني ماني",
    desc: "تعرف على أسهل إجراءات التقسيط المباشر في مصر، مع خيارات سداد مرنة تمتد حتى 60 شهراً لتناسب كافة الميزانيات والاحتياجات.",
    imageSrc: "/mmoney.png", 
    category: "خدمات مالية",
    author: "إدارة الائتمان",
    date: "15 يونيو 2026",
    readTime: "4 دقائق قراءة",
    isFeatured: false,
    tags: ["تقسيط", "ميني ماني", "خدمات مالية", "تسهيلات"],
    features: [
      "مرونة تامة في اختيار فترات السداد التي تبدأ من 6 أشهر وتصل لـ 60 شهراً.",
      "إجراءات تعاقد ميسرة وسريعة لضمان استلام أجهزتك دون تعقيدات.",
      "تغطية شاملة لكافة منتجات LaserJet المتاحة بالموقع والمعارض.",
      "تخطيط مالي أفضل من خلال مواءمة الأقساط الشهرية مع دخلك الخاص.",
      "متابعة مستمرة ودعم مباشر للرد على استفساراتك حول الأقساط."
    ],
    content: [
      "تسعى منصة 'ميني ماني' (Mini Money) التابعة لشركة ليزرجيت لتوفير حلول تمويلية وتقسيط ميسر يتيح للمستهلك المصري اقتناء أحدث الأجهزة المنزلية والإلكترونية ومستلزمات المعيشة دون تحمل أعباء مالية فورية ضخمة. نحن نؤمن بأهمية تسهيل سبل الحياة وتوفير التكنولوجيا الحديثة لكل منزل بذكاء ومرونة.",
      "يتميز نظام ميني ماني بالبساطة والسرعة في مراجعة الطلبات والموافقة الائتمانية، حيث يمكنك التقديم مباشرة عبر الموقع الإلكتروني أو من خلال التطبيق الهاتفي، مع إرفاق المستندات البسيطة المطلوبة. بعد الحصول على الموافقة، يمكنك الشراء فوراً وتنسيق خطة السداد المناسبة لظروفك المالية.",
      "نوفر باقة مرنة للغاية من خطط التقسيط (6، 12، 24، 36، 48، 60 شهراً) مع تقديم عروض بدون فوائد أو بدون مقدم في فترات مختلفة من العام. فريق خدمة العملاء متاح دائماً لشرح تفاصيل الفواتير والأقساط ومساعدتك في إدارة مدفوعاتك بطريقة آمنة ومريحة للغاية."
    ],
    contact: {
      title: "التسجيل وتقديم طلب تقسيط ميني ماني",
      phone: "01004331113",
      web: "minimoney.laserjet.com.eg",
      email: "minimoney@laserjet.com.eg"
    }
  },
  {
    id: "eshop",
    title: "دليل التسوق الآمن وتتبع الطلبات عبر متجر ليزرجيت الإلكتروني",
    desc: "اكتشف متعة التسوق الرقمي الآمن مع LaserJet E-Shop. دليل مبسط لاختيار المنتجات وتأكيد طلبك وتتبع شحنته حتى باب منزلك.",
    imageSrc: "/laser-jet-shop.png", 
    category: "التسوق الإلكتروني",
    author: "إدارة المتجر الإلكتروني",
    date: "12 يونيو 2026",
    readTime: "4 دقائق قراءة",
    isFeatured: false,
    tags: ["إي شوب", "تسوق إلكتروني", "دفع آمن", "تتبع الطلبات"],
    features: [
      "تصفح ذكي وفئات واضحة للإلكترونيات والأجهزة المنزلية بالمواصفات التقنية.",
      "إجراءات إتمام طلب ميسرة وسريعة في خطوات معدودة وآمنة.",
      "خيارات دفع متعددة (نقداً عند الاستلام، بطاقات ائتمان، محافظ إلكترونية).",
      "دعم فني متخصص لمساعدتك في الاستفسار عن الأجهزة أو ما بعد البيع.",
      "تتبع لحظي ودقيق لخط سير الطلبية وحالتها حتى تسليمها لباب منزلك.",
      "خصومات وعروض حصرية متجددة ومستمرة طوال العام للمتسوقين."
    ],
    content: [
      "يوفر متجر LaserJet E-Shop تجربة تسوق متكاملة تضع بين يديك آلاف الخيارات من الأجهزة المنزلية والأجهزة الذكية، مع توفير كامل تفاصيلها الفنية وأسعارها التنافسية. هدفنا هو جعل التسوق عبر الإنترنت عملية آمنة، ممتعة، ومريحة وخالية تماماً من التعقيدات.",
      "تم تصميم واجهة المتجر وتجربة المستخدم لتسهيل عملية الفلترة والمقارنة بين الموديلات المختلفة، مع إمكانية إضافة السلع لسلة المشتريات وإتمام الدفع بواسطة تشفير أمني متطور يضمن حماية تامة لبياناتك المصرفية، أو اختيار الدفع نقداً عند استلام المنتج وفحصه بالكامل.",
      "بمجرد تأكيد طلبك، يقوم نظام التتبع اللوجستي المتطور لدينا بإرسال تحديثات دورية عبر الرسائل النصية والبريد الإلكتروني لإعلامك بحالة الشحنة وتوقيت وصولها المتوقع. نضمن لك جودة التعبئة لضمان وصول المنتج في حالة ممتازة، بالإضافة لسياسة إرجاع مرنة تدعم حقوق المستهلك بالكامل."
    ],
    contact: {
      title: "زيارة متجر ليزرجيت الإلكتروني",
      phone: "01004331113",
      web: "laserjet.com.eg",
      email: "info@laserjet.com.eg"
    }
  },

];

export const CATEGORIES = ["الكل", "استثمار وشراكة", "ليزرجيت سيرفيس", "التاجر الرقمي", "خدمات مالية", "التسوق الإلكتروني", "استضافة واتصالات"];
